module.exports = __webpack_public_path__ + "static/img/model.780efde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/model.png
// module id = hnLP
// module chunks = 2